import { render, staticRenderFns } from "./ChatbotArchive.vue?vue&type=template&id=969934ae"
import script from "./ChatbotArchive.vue?vue&type=script&lang=js"
export * from "./ChatbotArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports